import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=8dc07a20&scoped=true&"
import script from "./NavComponent.vue?vue&type=script&lang=js&"
export * from "./NavComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=8dc07a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc07a20",
  null
  
)

export default component.exports